export const bonusAssignmentFields = `
  id
  tenant_id
  merchant_id
  bonus_component_id
  user_id
  payment_source
  clawback_applicable
  clawback_period
  assignment_status
  remarks
  created_at
  updated_at
  disbursements {
    id
    assignment_id
    tenant_id
    merchant_id
    user_id
    payroll_month
    amount
    payment_status
    clawback_fnf_payroll_month
    created_at
    updated_at
  }
`;
